<template>
  <div class="product__item">
    <div class="product__thumb fix">
      <div class="product-image w-img">
        <router-link :to="`/product-details/${product.product_id}`">
          <img :src="product.image" alt="product" />
        </router-link>
      </div>
      <div class="product__offer" v-if="product.discount_presentage">
        <span class="discount">-{{ product.discount_presentage }}%</span>
      </div>
      <div class="product-action">
        <!-- <a
            href="#"
            class="icon-box icon-box-1"
            data-bs-toggle="modal"
            :data-bs-target="`#${utilityStore.modalId}`"
            @click.prevent="utilityStore.handleOpenModal(`product-modal-${product.id}`, product)"
          >
            <i class="fas fa-eye"></i>
            <i class="fas fa-eye"></i>
          </a>
           -->

      </div>
    </div>
    <div class="product__content">
      <h6>
        <router-link :to="`/product-details/${product.product_id}`">{{ product.title }}</router-link>
      </h6>

      <div class="price mb-10">
        <h5><span>
          LKR {{ product.price }}
        </span></h5>
      </div>
     
      <!-- <div class="progress mb-5">
          <div
            class="progress-bar bg-danger"
            role="progressbar"
            :style="{ width: `${(product.sold / product.quantity) * 100}%` }"
            aria-valuenow="100"
            aria-valuemin="0"
            aria-valuemax="100"
          ></div>
        </div>
        <div class="progress-rate">
          <span>Sold: {{ product.sold }}/{{ product.quantity }}</span>
        </div> -->
    </div>
    <div class="product__add-cart text-center">
      <button v-if="!isItemInCart(product)" @click="cartStore.addCartProduct(product)" type="button"
        class="cart-btn product-modal-sidebar-open-btn d-flex align-items-center justify-content-center w-100">
        Add to Cart
      </button>
      <router-link :to="'/cart'" v-if="isItemInCart(product)"
        class="cart-btn product-modal-sidebar-open-btn d-flex align-items-center justify-content-center w-100">
        View Cart
      </router-link>
    </div>
  </div>
</template>

<script>
import { useCartStore } from "@/stores/useCartStore"
/* import { useWishlistStore } from "@/stores/wishlistStore";
import { useUtilsStore } from "@/stores/utilsStore";
import { useCompareStore } from "@/stores/compareStore"; */
import { calculateOriginalPrice } from "@/utils/utils"

export default {
  name: "ProductItem",
  props: {
    product: {
      type: Object,
      required: true,
    },
    

  },
  setup(props) {

    const cartStore = useCartStore()/* 
      const wishlistStore = useWishlistStore();
      const utilityStore = useUtilsStore();
      const compareStore = useCompareStore(); */

    /* function isItemInWishlist(product) {
      return wishlistStore.wishlists.some((prd) => prd.id === product.id);
    } */

    function isItemInCart(product) {
      return cartStore.cart_products.some((prd) => prd.id === product.id)
    }

    /* function isItemInCompare(product) {
      return compareStore.compare_items.some((prd) => prd.id === product.id);
    } */

    return {
      cartStore,
      /* wishlistStore,
      utilityStore,
      compareStore, 
      isItemInWishlist, */
      isItemInCart,
      /* isItemInCompare, */
      calculateOriginalPrice,
      // eslint-disable-next-line vue/no-dupe-keys
      product: props.product,
    }
  },
};
</script>

<style scoped>
.product-stock h5 del {
  color: #cc1414;
}
</style>